import { render, staticRenderFns } from "./file-download.vue?vue&type=template&id=67be3062&scoped=true&"
import script from "./file-download.vue?vue&type=script&lang=js&"
export * from "./file-download.vue?vue&type=script&lang=js&"
import style0 from "./file-download.vue?vue&type=style&index=0&id=67be3062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be3062",
  null
  
)

export default component.exports